/**
 * Global components
 * By Bhargav Shivaprasad <bshivaprasad@svb.com> (www.svb.com)
 * Summary
 * This component renders an SVB Solutions Headers
 */
import React from 'react';
import MetaTags from '../../core/MetaTags';
import { slugCreator } from "../../core/useStore";
import { SVBBreadCrumb } from "@svb/svb-react-components";
/**
 *
 * @param title: Title for the solution header
 * @param subTitle: Subtitle for the solutions header
 * @param description: Description text
 * @param headerImage: Right side image for the solutions header
 * @param headerIcon: Icon below title text
 * @param breadcrumbs: Array of objects containing the display text and path of the current navigation path
 * @returns SVB Solutions Headers as per SVB Design
 */
const SVBSolutionsHeader = (props) => {
  const title = props?.title ?? '';
  const subTitle = props?.subTitle ?? '';
  const description = props?.description ?? '';
  const headerImage = props?.headerImage ?? '';
  const headerIcon =
    props.headerIcon !== ''
      ? require('@svb/svbbranding/dist/assets/icons' + props.headerIcon)
      : '';
      let breadCrubsArray  =  window.location.pathname.split('/');
      let subHeaing0 = breadCrubsArray[1].toLowerCase().split('-').map((s) => s.charAt(0).toUpperCase() + s.substring(1)).join(' ');
      let subHeaing1 = breadCrubsArray[2].toLowerCase().split('-').map((s) => s.charAt(0).toUpperCase() + s.substring(1)).join(' ');
      let subHeaing2 = breadCrubsArray[3].toLowerCase().split('-').map((s) => s.charAt(0).toUpperCase() + s.substring(1)).join(' ');
      // let breadCrumbs = props?.breadcrumbs ?? '[]';
  // breadCrumbs = breadCrumbs.replace(/'/g, '"');
  // breadCrumbs = JSON.parse(breadCrumbs);
  return (
    <>
      <MetaTags title={title}
        sitename={"SVB Developer Portal"}
        description={description}
        image={window.location.protocol + "//" + window.location.host + "/svb_fcb_logo_new.svg"}
        keywords={"svb, silicon valley bank, api, developer, portal, integration, fcb, first citizens, use case, solution"}
        type="website"
        author="Silicon Valley Bank" />
      <div className="svb-solutions-header-container">
        <div className="svb-solutions-header-left-column">
        <div className="pt-4 svb-breadcrumb-header-color">
                <SVBBreadCrumb breadCrumbs={[
                { breadCrumb: 'Home', link: '/', dataTestId: 'breadcrumb-solution-details-home' },
                { breadCrumb: `${subHeaing0}`, link: `/${breadCrubsArray[1]}`, dataTestId: slugCreator(`breadcrumb-solution-details-${subHeaing0}`) },
                { breadCrumb: `${subHeaing1}`, link: `/${breadCrubsArray[1]}/${breadCrubsArray[2]}`, dataTestId: slugCreator(`breadcrumb-solution-details-${subHeaing1}`) },
                { breadCrumb: `${subHeaing2}`, link: '#', dataTestId: slugCreator(`breadcrumb-solution-details-${subHeaing2}`) }
                ]} extraClasses>
                </SVBBreadCrumb>
            </div>
          {/* {breadCrumbs?.length > 0 && (
            <div className="svb-solutions-header-breadcrumbs-margin">
              <ul className="list breadcrumbs--workspace d-flex align-center pl-24 pr-24">
                {breadCrumbs?.map((item, index) => {
                  return (
                    <React.Fragment key={index}>
                      <li className='d-flex'>
                        <a
                          href={item.href}
                          className={
                            breadCrumbs?.length === index
                              ? 'last-child svb-solutions-header-color-white'
                              : 'svb-solutions-header-color-white'
                          }
                        >
                          {item.displayText}
                        </a>
                        {breadCrumbs?.length - 1 !== index && (
                          <div>
                            <span className="faq-text02 oLDOtherLabel svb-solutions-header-color-white">
                              /
                            </span>
                          </div>
                        )}
                      </li>
                    </React.Fragment>
                  );
                })}
              </ul>
            </div>
          )} */}
          <div className="svb-solutions-header-text-container">
            <h1 className="heading-xlarge svb-solutions-header-color-white svb-solutions-header-padding-top-16">
              {title}
            </h1>

            {subTitle &&
              <h3 className="heading-small svb-solutions-header-color-white">
                {subTitle}
              </h3>
            }

            <div className='solution-header-content-wrapper'>
              <div className='col-md-4'>
                <img
                  src={headerIcon}
                  className="svb-solutions-header-icon svb-solutions-header-padding-top-16"
                  alt="soluton header icon"
                  width={320}
                  height={100}
                />
              </div>
              <div className='mt-2'>
                <p className="heading small svb-solutions-header-pre-line svb-solutions-header-color-white svb-solutions-header-padding-top-16 lh-base mb-0">
                  {description}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="svb-solutions-header-right-column">
          <img src={headerImage} className="svb-solutions-header-image" alt="solutions Header right background" width={320} height={470} />
        </div>
      </div>
    </>
  );
};

export default SVBSolutionsHeader;
